import React, { useState, useEffect } from 'react';
import { AlertTriangle, X, Trash2 } from 'lucide-react';
import Button from './Button';
import './DeletionConfirmModal.css';

/**
 * 위험한 삭제 작업을 위한 보안 확인 모달
 * 사용자가 특정 텍스트를 입력해야만 삭제 가능
 */
function DeletionConfirmModal({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  description, 
  confirmationText, 
  buttonText = "삭제",
  loading = false 
}) {
  const [inputValue, setInputValue] = useState('');
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setInputValue('');
      setIsValid(false);
    }
  }, [isOpen]);

  useEffect(() => {
    setIsValid(inputValue === confirmationText);
  }, [inputValue, confirmationText]);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleConfirm = () => {
    if (isValid && !loading) {
      onConfirm();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && isValid && !loading) {
      handleConfirm();
    }
    if (e.key === 'Escape') {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="deletion-modal-overlay">
      <div className="deletion-modal">
        <div className="deletion-modal-header">
          <div className="header-content">
            <AlertTriangle size={24} className="warning-icon" />
            <h2>{title}</h2>
          </div>
          <button 
            className="close-button" 
            onClick={onClose}
            disabled={loading}
          >
            <X size={18} />
          </button>
        </div>

        <div className="deletion-modal-body">
          <div className="warning-content">
            <p>{description}</p>
          </div>

          <div className="confirmation-section">
            <label htmlFor="confirmation-input" className="confirmation-label">
              아래 텍스트를 정확히 입력하여 확인해주세요:
            </label>
            <div className="confirmation-text-display">
              <code>{confirmationText}</code>
            </div>
            <input
              id="confirmation-input"
              type="text"
              value={inputValue}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              className={`confirmation-input ${isValid ? 'valid' : ''}`}
              placeholder={`"${confirmationText}" 입력`}
              autoComplete="off"
              disabled={loading}
              autoFocus
            />
            {inputValue && !isValid && (
              <div className="validation-message">
                입력한 텍스트가 일치하지 않습니다.
              </div>
            )}
            {isValid && (
              <div className="validation-message valid">
                ✓ 확인되었습니다.
              </div>
            )}
          </div>
        </div>

        <div className="deletion-modal-footer">
          <Button
            variant="secondary"
            onClick={onClose}
            disabled={loading}
          >
            취소
          </Button>
          <Button
            variant="danger"
            onClick={handleConfirm}
            disabled={!isValid || loading}
            loading={loading}
          >
            <Trash2 size={16} />
            {loading ? '처리 중...' : buttonText}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default DeletionConfirmModal;